'use strict';

exports.__esModule = true;
exports.PATTERNS = undefined;

var _props, _props2, _props3, _props4, _props5, _props6, _props7, _props8, _props9, _props10, _props11, _props12, _props13, _props14, _props15, _props16, _props17, _props18, _props19, _props20, _props21, _props22, _props23, _props24, _props25, _props26, _props27, _props28, _props29, _PATTERNS;

var _ItemTypes = require('../types/ItemTypes');

var _Identifiers = require('../types/Identifiers');

var _TagTypes = require('../types/TagTypes');

var _Props = require('../types/Props');

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PATTERNS = exports.PATTERNS = (_PATTERNS = {}, _PATTERNS[_ItemTypes.ITEM_TYPES.STATIC_PAGE] = {
  tags: [{
    type: _TagTypes.TAG_TYPES.TITLE,
    children: '{{page.title}}'
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props = {}, _props[_Props2.default.NAME] = 'description', _props[_Props2.default.CONTENT] = '{{page.description}}', _props)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props2 = {}, _props2[_Props2.default.PROPERTY] = 'og:title', _props2[_Props2.default.CONTENT] = '{{@' + _Identifiers.IDENTIFIERS.TITLE + '}}', _props2)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props3 = {}, _props3[_Props2.default.PROPERTY] = 'og:description', _props3[_Props2.default.CONTENT] = '{{@' + _Identifiers.IDENTIFIERS.DESCRIPTION + '}}', _props3)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props4 = {}, _props4[_Props2.default.PROPERTY] = 'og:url', _props4[_Props2.default.CONTENT] = '{{page.url}}', _props4)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props5 = {}, _props5[_Props2.default.PROPERTY] = 'og:site_name', _props5[_Props2.default.CONTENT] = '{{site.name}}', _props5)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props6 = {}, _props6[_Props2.default.PROPERTY] = 'og:type', _props6[_Props2.default.CONTENT] = 'website', _props6)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props7 = {}, _props7[_Props2.default.PROPERTY] = 'og:image', _props7[_Props2.default.CONTENT] = '{{page.image}}', _props7)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props8 = {}, _props8[_Props2.default.PROPERTY] = 'og:image:width', _props8[_Props2.default.CONTENT] = '{{page.imageWidth}}', _props8)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props9 = {}, _props9[_Props2.default.PROPERTY] = 'og:image:height', _props9[_Props2.default.CONTENT] = '{{page.imageHeight}}', _props9)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props10 = {}, _props10[_Props2.default.PROPERTY] = 'fb:admins', _props10[_Props2.default.CONTENT] = '{{site.facebookAdminId}}', _props10)
  },
  // TODO: Uncomment once twitter is added again
  // {
  //   type: TAG_TYPES.META,
  //   props: {
  //     [PROPS.NAME]: 'twitter:title',
  //     [PROPS.CONTENT]: `{{@${IDENTIFIERS.OG_TITLE}}}`,
  //   },
  // },
  // {
  //   type: TAG_TYPES.META,
  //   props: {
  //     [PROPS.NAME]: 'twitter:description',
  //     [PROPS.CONTENT]: `{{@${IDENTIFIERS.OG_DESCRIPTION}}}`,
  //   },
  // },
  // {
  //   type: TAG_TYPES.META,
  //   props: {
  //     [PROPS.NAME]: 'twitter:image',
  //     [PROPS.CONTENT]: `{{@${IDENTIFIERS.OG_IMAGE}}}`,
  //   },
  // },
  // {
  //   type: TAG_TYPES.META,
  //   props: {
  //     [PROPS.NAME]: 'twitter:site',
  //     [PROPS.CONTENT]: '{{site.name}}',
  //   },
  // },
  {
    type: _TagTypes.TAG_TYPES.LINK,
    props: (_props11 = {}, _props11[_Props2.default.REL] = 'canonical', _props11[_Props2.default.HREF] = '{{page.url}}', _props11)
  }, {
    type: _TagTypes.TAG_TYPES.LINK,
    props: (_props12 = {}, _props12[_Props2.default.REL] = 'next', _props12[_Props2.default.HREF] = '{{site.next}}', _props12)
  }, {
    type: _TagTypes.TAG_TYPES.LINK,
    props: (_props13 = {}, _props13[_Props2.default.REL] = 'prev', _props13[_Props2.default.HREF] = '{{site.prev}}', _props13)
  }, {
    type: _TagTypes.TAG_TYPES.LINK,
    props: (_props14 = {}, _props14[_Props2.default.REL] = 'next', _props14[_Props2.default.HREF] = '{{site.next}}', _props14)
  }]
}, _PATTERNS[_ItemTypes.ITEM_TYPES.STORES_PRODUCT] = {
  tags: [{
    type: _TagTypes.TAG_TYPES.TITLE,
    children: '{{product.name}}'
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props15 = {}, _props15[_Props2.default.NAME] = 'description', _props15[_Props2.default.CONTENT] = '{{product.description}}', _props15)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props16 = {}, _props16[_Props2.default.PROPERTY] = 'og:title', _props16[_Props2.default.CONTENT] = '{{@' + _Identifiers.IDENTIFIERS.TITLE + '}}', _props16)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props17 = {}, _props17[_Props2.default.PROPERTY] = 'og:description', _props17[_Props2.default.CONTENT] = '{{@' + _Identifiers.IDENTIFIERS.DESCRIPTION + '}}', _props17)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props18 = {}, _props18[_Props2.default.PROPERTY] = 'og:url', _props18[_Props2.default.CONTENT] = '{{page.url}}', _props18)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props19 = {}, _props19[_Props2.default.PROPERTY] = 'og:site_name', _props19[_Props2.default.CONTENT] = '{{site.name}}', _props19)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props20 = {}, _props20[_Props2.default.PROPERTY] = 'og:type', _props20[_Props2.default.CONTENT] = 'product', _props20)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props21 = {}, _props21[_Props2.default.NAME] = 'twitter:title', _props21[_Props2.default.CONTENT] = '{{@' + _Identifiers.IDENTIFIERS.OG_TITLE + '}}', _props21)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props22 = {}, _props22[_Props2.default.NAME] = 'twitter:description', _props22[_Props2.default.CONTENT] = '{{@' + _Identifiers.IDENTIFIERS.OG_DESCRIPTION + '}}', _props22)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props23 = {}, _props23[_Props2.default.NAME] = 'twitter:image', _props23[_Props2.default.CONTENT] = '{{@' + _Identifiers.IDENTIFIERS.OG_IMAGE + '}}', _props23)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props24 = {}, _props24[_Props2.default.NAME] = 'twitter:site', _props24[_Props2.default.CONTENT] = '{{site.name}}', _props24)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props25 = {}, _props25[_Props2.default.NAME] = 'robots', _props25[_Props2.default.CONTENT] = 'index', _props25)
  }, {
    type: _TagTypes.TAG_TYPES.LINK,
    props: (_props26 = {}, _props26[_Props2.default.REL] = 'canonical', _props26[_Props2.default.HREF] = '{{page.url}}', _props26)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props27 = {}, _props27[_Props2.default.PROPERTY] = 'product:price:amount', _props27[_Props2.default.CONTENT] = '{{product.price}}', _props27)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props28 = {}, _props28[_Props2.default.PROPERTY] = 'product:price:currency', _props28[_Props2.default.CONTENT] = '{{product.currency}}', _props28)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props29 = {}, _props29[_Props2.default.PROPERTY] = 'og:availability', _props29[_Props2.default.CONTENT] = '{{product.availability}}', _props29)
  }]
}, _PATTERNS[_ItemTypes.ITEM_TYPES.DEFAULT] = {}, _PATTERNS);